<template>
  <QMarkupTable>
    <thead>
      <tr class="text-left">
        <th>Role</th>
        <th>Description</th>
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="role in roles"
        :key="role"
      >
        <td class="text-left">
          {{ capitalize(role) }}
        </td>
        <td class="text-left">
          {{ description(role) }}
        </td>
      </tr>
    </tbody>
  </QMarkupTable>
</template>

<script>
import { capitalize } from "shared/helpers/string";

export default {
  name: "SocialRolesPermissionsTable",
  data() {
    return {
      rolesPermissionsData: {
        none: "No access to social.",
        "listen analyse": "Full access to Listen and Anaylse only.",
        engage:
          "Access to Engage only -Can not authorise/publish/delete posts. NO access to Listen or Analyse.",
        "engage super":
          "Access to Engage only with permission to authorise posts. NO access to Listen or Analyse.",
        full: "Access to all social features across analyse/listen/engage. Can create/schedule post - cannot approve/publish or delete posts.",
        super:
          "Access to all social features, approve post/delete post, create/schedule/publish/access to all features across analyse/listen/engage.",
      },
    };
  },
  computed: {
    roles() {
      return Object.keys(this.rolesPermissionsData);
    },
  },
  methods: {
    capitalize,
    description(role) {
      return this.rolesPermissionsData[role];
    },
  },
};
</script>

<style lang="scss" scoped>
.q-table th {
  font-weight: bold;
}
</style>
